import Stock from "../../slices/inventory/stock/Stock"

const inventoryReducer = {
    stock: Stock,
};

export default inventoryReducer;